import { useState } from "react";
import { useAtom } from "jotai";
import { getCountries, type Country } from "react-phone-number-input";
import { signUpDataAtom } from "store/signUpStore";
import { useSignupPolicy } from "hooks/useSignupPolicy";
import { IdentityGlobalPhoneForm, IdentityGlobalPhoneResult } from "components/identity/IdentityGlobalPhoneForm";

/**
 * Step12: 보호자 휴대전화 번호 (법정대리인 동의 대상)
 *
 * 이 번호로 법정대리인 동의 요청 문자가 간다. 보호자는 이 번호로 가입·인증한 계정에서만 동의할 수 있다.
 * 다음: 인증 단계 (본인 휴대폰 인증 시 이 번호와 같은 번호는 쓸 수 없다)
 */
export const SignUpStep12 = () => {
    const [signUpData, setSignUpData] = useAtom(signUpDataAtom);
    const { routeToAuth } = useSignupPolicy();

    const [initialCountry] = useState<Country>(() => {
        const countries = getCountries();
        if (signUpData.countryCd && countries.includes(signUpData.countryCd as Country)) {
            return signUpData.countryCd as Country;
        }
        return "KR" as Country;
    });

    const handleNext = (result: IdentityGlobalPhoneResult) => {
        const updated = {
            ...signUpData,
            guardianCtn: result.phone,
            guardianCtnCountryCd: result.ctnCountryCd,
        };
        setSignUpData(updated);
        routeToAuth(updated);
    };

    return (
        <IdentityGlobalPhoneForm
            initialCountry={initialCountry}
            initialPhone={signUpData.guardianCtn || ""}
            titleI18nKey="signUp.step12.title"
            infoI18nKey="signUp.step12.info"
            onNext={handleNext}
        />
    );
};
